import { atom } from 'recoil'

export const isOpenOverlayState = atom<boolean>({
  key : 'isOpenOverlayState',
  default : false
})